import { render, staticRenderFns } from "./PreguntasFrecuentes.vue?vue&type=template&id=42228e07&scoped=true"
import script from "./PreguntasFrecuentes.vue?vue&type=script&lang=js"
export * from "./PreguntasFrecuentes.vue?vue&type=script&lang=js"
import style0 from "./PreguntasFrecuentes.vue?vue&type=style&index=0&id=42228e07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42228e07",
  null
  
)

export default component.exports